import { styled } from '@linaria/react';

export const DesktopOnlyText = styled.span`
  display: none;
  font-size: 16px;

  @media (min-width: 768px) {
    display: inline-block;
  }
`;

export const MobileOnlyText = styled.span`
  display: inline-block;
  font-size: 14px;

  @media (min-width: 390px) {
    font-size: 16px;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

export const TeamWrapper = styled.div`
  display: flex;
  align-items: center;

  & > p {
    display: inline-block;
    font-family: var(--ogm-font-family-2);
    font-style: normal;
    font-weight: var(--cxy-fontWeight-bold);
    line-height: 24px;
    color: var(--ogm-text-body);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;
    margin: 0;
  }
`;

export const TeamBadge = styled.div`
  display: inline-block;
  margin-right: 8px;
  width: 18px;
  height: 18px;

  @media (min-width: 768px) {
    width: 22px;
    height: 22px;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const BetName = styled.p`
  font-family: var(--oc-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: var(--ogm-text-body);
`;
